import React, { ReactNode } from "react"
import { Box } from "@chakra-ui/react"
import { FormType } from "sharedTypes"
import { useLocation } from "react-router-dom"
import { eventPath } from "utilities/routes"
import Link from "components/elements/Link"
import Popover from "./Popover"
import {
  ActivityPopoverContent,
  ActivityPopoverDeleteFormSubmissionLineItem,
  ActivityPopoverRow, ActivityPopoverSection,
} from "./ActivityPopover"
import MenuLink from "./Popover/MenuLink"
import { asDateWithTZ } from "../../utilities/strings"

type MenuProps = {
  guestId: string
  formType: FormType
  formSubmissionName: string
  isTicket: boolean
  externalId: string
  formSubmissionExternalId: string
  lineItemUrl?: string
  receiptUrl?: string
  payment: string
  createdAt: string
  timeZone: string
  eventId?: string
  onDeleted?: () => void
  onSubmissionDeleted?: () => void
}

type Props = MenuProps & {
  trigger: ReactNode
  header: string
}

export const FormSubmissionLineItemMenu = ({
  guestId,
  formType,
  formSubmissionName,
  isTicket,
  externalId,
  formSubmissionExternalId,
  lineItemUrl,
  receiptUrl,
  payment,
  createdAt,
  timeZone,
  eventId,
  onDeleted,
  onSubmissionDeleted,
}: MenuProps) => {
  const submitted = asDateWithTZ(createdAt, timeZone) || "N/A"
  const location = useLocation()

  return (
    <ActivityPopoverContent>
      <ActivityPopoverSection>
        <ActivityPopoverRow label="Submitted" value={submitted} />
        {isTicket && (
          <ActivityPopoverRow label="Payment" value={payment} />
        )}
        <ActivityPopoverRow label="Reference" value={externalId} />
      </ActivityPopoverSection>
      {eventId && (
        <Link
          to={{ pathname: `${eventPath(eventId)}/guests/${guestId}`, state: { background: location } }}
          color="inherit"
          _hover={{ textDecoration: "none" }}
        >
          <MenuLink icon="guest-profile" label="Guest Profile" />
        </Link>
      )}
      {formType === FormType.Ticket && receiptUrl && (
        <Box
          as="a"
          href={receiptUrl}
          target="_blank"
        >
          <MenuLink
            icon="orders-outline"
            label={`${formType === "Ticket" ? "Order" : formType} Receipt`}
            hasRightLinkIcon
          />
        </Box>
      )}
      {lineItemUrl && (
        <Box as="a" href={lineItemUrl} target="_blank">
          <MenuLink
            icon="submission"
            label={`Guest ${formType} Page`}
            hasRightLinkIcon
          />
        </Box>
      )}
      <ActivityPopoverDeleteFormSubmissionLineItem
        externalId={externalId}
        name={formSubmissionName}
        guestId={guestId}
        formSubmissionExternalId={formSubmissionExternalId}
        eventId={eventId}
        onDeleted={onDeleted}
        onSubmissionDeleted={onSubmissionDeleted}
      />
    </ActivityPopoverContent>
  )
}

const FormSubmissionLineItemActivityPopup = ({ trigger, header, ...menuProps }: Props) => (
  <Popover
    placement="top-end"
    trigger={trigger}
    header={header}
    body={<FormSubmissionLineItemMenu {...menuProps} />}
  />
)

export default FormSubmissionLineItemActivityPopup
